import { KpiTile } from "./KpiTile";

type LossTileProps = {
  loss: number | null;
  prev: number | null;
  hasTarget: boolean;
};

export function LossTile({ loss, prev, hasTarget }: LossTileProps) {
  if (!hasTarget) {
    return (
      <KpiTile
        label="Loss"
        dim
        tooltip={{
          label: "Loss · Target ↔ Current sensory distance",
          sublabel:
            "Set a target flavor to compare. Weighted L2 distance to target across taste (9) + smell (20) axes. Lower is closer to target.",
        }}
      >
        <span
          className="mono"
          style={{ fontSize: 12, color: "var(--ink-4)", fontWeight: 500 }}
        >
          — no target
        </span>
      </KpiTile>
    );
  }

  if (loss === null || loss === undefined) {
    return (
      <KpiTile label="Loss" dim>
        <span className="kpi-num empty">—</span>
      </KpiTile>
    );
  }

  const showDelta = prev !== null && prev !== undefined && Math.abs(prev - loss) > 0.005;
  const delta = showDelta ? loss - prev! : 0;
  const better = delta < 0;

  return (
    <KpiTile
      label="Loss"
      tooltip={{
        label: `Loss · ${loss.toFixed(2)}`,
        sublabel:
          "Weighted L2 distance to target across taste (9) + smell (20) axes. Lower is closer to target.",
      }}
    >
      <span className="kpi-num">{loss.toFixed(2)}</span>
      {showDelta && (
        <span className={`kpi-delta ${better ? "better" : "worse"}`}>
          {better ? "▼" : "▲"} {Math.abs(delta).toFixed(2)}
        </span>
      )}
    </KpiTile>
  );
}
